import React, { useState, useEffect } from 'react';
import axiosInstance from '../../services/axiosInstance';
import { Box, Typography, Divider, Button, Stack, Modal, TextField, Checkbox, FormControlLabel, InputAdornment, Grid, Card, Icon, MenuItem, Menu, FormControl, RadioGroup, Radio, Switch, Select, IconButton } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useOutletContext, useNavigate } from "react-router-dom";
import { esignToolApi } from '../../services/esignApi';
import { esignIcons } from './icons';
import { selectOptions } from '../../store/reducers/pdfeditor/selectOptionsSlice';
import { toggleFullView } from "../../store/reducers/uploadDocumentSlice";
import ReviewAndSend from './reviewAndSend';
import { removeSigner, setSigners, updateSignerEsignType } from '../../store/reducers/signerSlice';
import PdfControls from '../PdfEditor/Pdf-Rederer/PdfControls';
import { deleteCoordinatesBySigner, bulkUpdateCoordinates } from '../../store/reducers/pdfeditor/pdfCoordinatesSlice';
import { useLogger } from '../../hooks/useLogger';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
export default function AddSigners({ containerRef, pdfPagesRef, pdfPages }) {
    const logEvent = useLogger();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { setOpenSideBar, openSideBar } = useOutletContext();
    const { options } = useSelector((state) => state.selectOptions || []);
    const { profileData } = useSelector((state) => state.profile);
    const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
    const { uploadedDocument} = useSelector((state) => state.uploadDocument);
    const { coordinates } = useSelector((state) => state.pdfCoordinates || []);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [editSelectSignerOpen, setEditSelectSignerOpen] = useState(false);
    const [reviewAndSend, setReviewAndSend] = useState(false);
    const [updateSigner, setUpdateSigner] = useState(false);
    const [saveDraft, setSaveDraft] = useState(false);
    const [deleteSignerOpen, setDeleteSignerOpen] = useState(false);
    const [newSigner, setNewSigner] = useState(true);
    const [addedSigners, setAddedSigners] = useState(false);
    const [aadhaarCount, setAadhaarCount] = useState(0);
    const [digitalCount, setDigitalCount] = useState(0);
    const { signers } = useSelector((state) => state.signers);
    const [frequentSigner, setFrequentSigner] = useState([]);
    const [numSigners, setNumSigners] = useState(0);
    const [signername, setSignerName] = useState("");
    const [signeremail, setSignerEmail] = useState("");
    const [singerNumber, setSignerNumber] = useState("");
    const [singerPlace, setSignerPlace] = useState("");
    const [signerReason, setSignerReason] = useState("");
    const [signerEsignType, setSignerEsignType] = useState("aadhaar-signature");
    const [signerOtherReason, setSignerOtherReason] = useState("");
    const [saveFutureRefrences, setSaveFutureRefrences] = useState(false);
    const [checkedSigners, setCheckedSigners] = useState({});
    const [errors, setErrors] = useState({ signername: "", signeremail: "", singerNumber: "", singerPlace: "", saveFutureRefrences: "", signerReason: "", signerOtherReason: "", signerEsignType:"", });
    const [helperText, setHelperText] = useState({ signername: "", signeremail: "", singerNumber: "", singerPlace: "", saveFutureRefrences: "", signerReason: "", signerOtherReason: "", signerEsignType:"", });
    const [anchorEl, setAnchorEl] = useState(null);
    const [anchorSelectSigner, setAnchorSelectSigner] = useState(null);
    const [selectedSigner, setSelectedSigner] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectMode, setSelectMode] = useState(false);
    const [selectedSigners, setSelectedSigners] = useState([]);
    const [selectedEsignType, setSelectedEsignType] = useState("aadhaar-signature");
    const [signerSequenceMismatch, setSignerSequenceMismatch] = useState(false);
    
    const isButtonDisabled = !Object.keys(uploadedDocument ? uploadedDocument?.data?.document_template || {} : {}).length;

    useEffect(() => {
        if (Array.isArray(signers) && signers.length > 0) {
            let aadhaar = 0;
            let digital = 0;
        
            signers.forEach(signer => {
                if (signer.esign_type_new === 'digital-signature') {
                    digital += 1;
                } else {
                    aadhaar += 1;
                }
            });
      
          setAadhaarCount(aadhaar);
          setDigitalCount(digital);
        }
        else
        {
            setAadhaarCount(0);
            setDigitalCount(0);
        }
    }, [signers]);

    const filterSigners = (frequentSigner, searchTerm) => {
        logEvent('Clicked', 'Search added signers', 'New-eSign/signers');
        return frequentSigner.filter((signer) =>
            signer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            signer.email.toLowerCase().includes(searchTerm.toLowerCase())
        );
    };

    const filteredSigners = filterSigners(frequentSigner, searchTerm);

    const handlesaveFutureRefrences = (event) => {
        setSaveFutureRefrences(event.target.checked);
    };

    const handleReviewAndSend = () => {
        logEvent('Clicked', 'Review and Send clicked', 'New-eSign/signers');
        setReviewAndSend(true);
        // if(isButtonDisabled)
        // {
        //     dispatch(toggleFullView()); 
        //     setOpenSideBar(false); 
        //     navigate("/esign/pdfeditor", { replace: true });
        // }
        // else {
        //     setReviewAndSend(true);
        // }
    }

    const handleAddSavedSigner = (event, signerId) => {
        logEvent('checked', 'checked added signers', 'New-eSign/signers');
        setCheckedSigners((prev) => {
            const newCheckedSigners = { ...prev };
    
            if (event.target.checked) {
                newCheckedSigners[signerId] = true;
            } else {
                delete newCheckedSigners[signerId];
            }
    
            return newCheckedSigners;
        });
    };

    const validateEmail = (value) => {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(value);
    };

    const validatePhoneNumber = (value) => {
        const phonePattern = /^[6-9]\d{9}$/;
        return phonePattern.test(value);
    };

    const validateSignerData = () => {
        const errors = {};
        if (!signername) errors.signername = "Name is required.";
        if (!signeremail) {
            errors.signeremail = "Email is required.";
        } else if (!validateEmail(signeremail)) {
            errors.signeremail = "Invalid email address.";
        }
    
        // if (!singerNumber) {
        //     errors.singerNumber = "Phone number is required.";
        // } else 
        if (singerNumber && !validatePhoneNumber(singerNumber)) {
            errors.singerNumber = "Enter a valid 10-digit mobile number starting with 6-9.";
        }

        if (!singerPlace) errors.singerPlace = "Place is required.";

        if (!signerReason) {
            errors.signerReason = "Reason is required.";
        } else if (signerReason.toLowerCase() === "other" && !signerOtherReason) {
            errors.signerOtherReason = "Specify Other Reason.";
        }
    
        if (Object.keys(errors).length) {
            setErrors(errors);
            setHelperText(errors);
            return false;
        }
        return true;
    };

    const clearAllErrors = () => {
        const cleared = {
          signername: "",
          signeremail: "",
          singerNumber: "",
          singerPlace: "",
          saveFutureRefrences: "",
          signerReason: "",
          signerEsignType: "",
          signerOtherReason: ""
        };
        setErrors(cleared);
        setHelperText(cleared);
    };
      
    const resetSignerForm = () => {
        setSelectedSigner(null);
        setSignerName("");
        setSignerEmail("");
        setSignerNumber("");
        setSignerPlace("");
        setSignerReason("");
        setSignerEsignType("aadhaar-signature")
        setSignerOtherReason("");
        setSaveFutureRefrences(false);
        setPreviewOpen(false);
    };

    const handleAddOrUpdateSigners = async (isUpdate) => {
        logEvent('Clicked', `${isUpdate ? 'Update existing signer' : 'Add New Signer'}`, 'New-eSign/signers');

        if (!validateSignerData()) return;

        let isEmailExist = signers.some(signer => signer.email === signeremail)
        if(isEmailExist && !updateSigner){
            setErrors((prev) => ({
                ...prev,
                signeremail: `This email already exists.`,
            }));
        
            setHelperText((prev) => ({
                ...prev,
                signeremail: `This email already exists.`,
            }));
            return;
        }
        const signerData = {
            id: isUpdate ? selectedSigner.id : undefined,
            name: signername,
            email: signeremail,
            phone: singerNumber ? singerNumber : '1111111111',
            place: singerPlace,
            reason: signerReason,
            other_reason_value: signerOtherReason,
            esign_type_new: signerEsignType,
            sequence: isUpdate ? selectedSigner.sequence : signers.length + 1,
            frequent_signer: saveFutureRefrences,
        };

        try {
            const response = isUpdate
                ? await esignToolApi.updateManualSigner(signerData, uploadedDocument?.data?.document_id)
                : await esignToolApi.saveManualSigner(signerData, uploadedDocument?.data?.document_id);
            
            console.log(`${isUpdate ? "Updated" : "Saved"} Signer Response:`, response);
            resetSignerForm();
            setNumSigners(signers.length + 1);
            if (isUpdate) {
                dispatch(setSigners(
                    signers.map(s => s.id === selectedSigner.id ? { ...s, ...signerData } : s)
                ));
            } else {
                dispatch(setSigners([...signers, response.signer]));  
            }
        } catch (error) {
            console.error("Error saving/updating draft:", error);
        }
    };

    const prepareSignerPayload = () => {
        return frequentSigner
        .filter(signer => checkedSigners[signer.id])
        .map(signer => signer.id);
    };

    const handleAddFrequentSigners = async () => {
        logEvent('Clicked', 'Signers added from frequent singers', 'New-eSign/signers');
        const payload = { id: prepareSignerPayload() };
        console.log("Final Payload to Send:", payload);
        try {
            const response = await esignToolApi.addSignerfromFrequent(
                payload, 
                uploadedDocument?.data?.document_id, 
            );
            console.log("Added Frequent Signers Response:", response);
            resetSignerForm();
            fetchSignersData(uploadedDocument?.data?.document_id);
        } catch (error) {
            console.error("Error saving draft:", error);
        }
    }

    const fetchSignersData = async (documentID) => {
        try {
            const response = await esignToolApi.fetchManualSigner(documentID);
            console.log("API Response:", response);

            if (response) {        
                dispatch(setSigners(response));
                setNumSigners(response.length);
                const newOptions = response.map((signer, index) => ({
                    value: { variableName: `signer-${index + 1}`, data_type: "watermark_image", values: [] },
                    label: `signer-${index + 1}`
                })); 
                console.log("newOptions",newOptions);
                dispatch(selectOptions(newOptions));
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if(error?.response?.data?.message=="No signers found")
            {
                dispatch(setSigners([]));
                setNumSigners(0);
            }
        }
    };

    const fetchfrequentSignersData = async () => {
        try {
            const response = await esignToolApi.fetchfrequentSigner();
            if (response) {        
                setFrequentSigner(response.data);
            }

        } catch (error) {
            console.error("Error fetching frequent signers:", error);
        }
    };
    
    useEffect(() => {
        if (uploadedDocument?.data?.document_id) {
            fetchSignersData(uploadedDocument?.data?.document_id);
        }
    }, [uploadedDocument?.data?.document_id]);

    const handleMenuOpen = (event, signer) => {
        setAnchorEl(event.currentTarget);
        console.log(signer)
        setSelectedSigner(signer);
    };

    const handleSelectSignerOpen = (event) => {
        setAnchorSelectSigner(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        resetSignerForm();
    };

    const handleSelectSignerClose = () => {
        setAnchorSelectSigner(null);
    };

    const handleEdit = () => {
        logEvent('Clicked', 'Edit Signer popup open', 'New-eSign/signers');
        setSignerName(selectedSigner.name)
        setSignerEmail(selectedSigner.email)
        setSignerNumber(selectedSigner.phone == '1111111111' ? '' : selectedSigner.phone)
        setSignerPlace(selectedSigner.place)
        setSignerReason(selectedSigner.reason)
        setSaveFutureRefrences(selectedSigner.frequent_signer)
        setSignerOtherReason(selectedSigner.other_reason_value)
        setSignerEsignType(selectedSigner.esign_type_new)
        setPreviewOpen(true);
        setUpdateSigner(true);
        setAddedSigners(false);
        setAnchorEl(null);
        setNewSigner(true);
        clearAllErrors();
    };

    const handleDelete = () => {
        logEvent('Clicked', 'Delete signer popup opend', 'New-eSign/signers');
        setDeleteSignerOpen(true);
        setAnchorEl(null);
    };


    const handleDeleteSigners = async () => {
        logEvent('Clicked', 'Delete Signer Clicked', 'New-eSign/signers');

        try {
            console.log(selectedSigner)
            const response = await esignToolApi.deleteManualSigner(selectedSigner.id);
            console.log("API Response:", response);
    
            if (response && response.status===200) {
                setDeleteSignerOpen(false);
                dispatch(removeSigner(selectedSigner.id));
                const signerIndex = signers.findIndex(signer => signer.id === selectedSigner.id);
                dispatch(deleteCoordinatesBySigner(selectedSigner));
                setSelectedSigner(null);
                setNumSigners(numSigners - 1);
                fetchSignersData(uploadedDocument?.data?.document_id);
            } else {
                console.error("Failed to delete signer:", response);
            }
        } catch (error) {
            console.error("Error deleting signer:", error);
        }
    };    

    const AddMoreSigner = () =>
    {
        logEvent('Clicked', 'Add More Signer Clicked', 'New-eSign/signers');
        setSignerName("")
        setSignerEmail("")
        setSignerNumber("")
        setSignerPlace("")
        setSignerReason("")
        setSignerOtherReason("")
        setSignerEsignType("aadhaar-signature")
        setPreviewOpen(true)
        setUpdateSigner(false)
        setNewSigner(true);
        setAddedSigners(false);
    }

    console.log("signers",signers)
    
    useEffect(() => {
        if(!addedSigners) setSearchTerm("")
    }, [addedSigners])

    const handleDragEnd = async (result) => {
        logEvent('Dragged', "Drag from", result.source.index, "to", result.destination?.index, 'New-eSign/signers');
        if (!result.destination) return;
    
        const updated = Array.from(signers);
        const [moved] = updated.splice(result.source.index, 1);
        updated.splice(result.destination.index, 0, moved);
    
        // Update sequence
        const reordered = updated.map((signer, index) => ({
            ...signer,
            oldSequence: parseInt(signer.sequence, 10),
            sequence: index + 1, // <-- integer
        }));
        
        const sequenceUpdates = reordered.map(({ id, sequence }) => ({ id, sequence }));
        dispatch(setSigners(reordered));
        try {
            const response = await esignToolApi.changeSequenceOfSigner(sequenceUpdates);
            if (response && response.status===200) {
                const coordinateUpdates = reordered
                    .filter(({ oldSequence, sequence }) => oldSequence !== sequence)
                    .map(({ oldSequence, sequence }) => ({
                        id: `signer-${oldSequence}`,
                        newValue: { value: `signer-${sequence}` }
                    }));

                if (coordinateUpdates.length > 0) {
                    dispatch(bulkUpdateCoordinates(coordinateUpdates));
                }
                fetchSignersData(uploadedDocument?.data?.document_id);
            } else {
                console.error("Failed to delete signer:", response);
            }
        } catch (error) {
            console.error("Error deleting signer:", error);
        }
    };
    
    const handleSelectSigners = () => {
        setSelectMode((prev) => !prev);
        setSelectedSigners([]);
        handleSelectSignerClose();
    };

    const handleCheckboxChange = (signerId) => {
        const signer = signers.find((s) => s.id === signerId);      
        if (selectedSigners.length === 0) {
            setSelectedSigners([signerId]);
        } else {        
            if (selectedSigners.includes(signerId)) {
                setSelectedSigners((prev) => prev.filter((id) => id !== signerId));
            } else {
                setSelectedSigners((prev) => [...prev, signerId]);
            }
        }
    };
      
    const handleEsignTypeChange = (e) => {
        setSelectedEsignType(e.target.value);
    };

    const handleUpdateEsignType = async () => {
        logEvent('Clicked', 'Update Signers Esign Type', 'New-eSign/signers');
        try {
            const payload = selectedSigners.map((id) => ({
                id,
                esign_type_new: selectedEsignType,
            }));
            const response = await esignToolApi.updateEsignType(payload);
            if (response && response.status===200) {
                setEditSelectSignerOpen(false);
                setSelectMode(false);
                setSelectedSigners([]);
                dispatch(updateSignerEsignType(payload));
                fetchSignersData(uploadedDocument?.data?.document_id);
            } else {
                console.error("Failed to delete signer:", response);
            }
        } catch (error) {
            console.error("Error deleting signer:", error);
        }
    };

    const handleDeleteSelectedSigners = async () => {
        logEvent('Clicked', 'Multi Delete Signers Clicked', 'New-eSign/signers');
        if (selectedSigners.length === 0) {
            alert("Please select at least one signer to delete.");
            return;
        }
        try {
            const payload = {
                ids: selectedSigners
            };
            const response = await esignToolApi.deleteMultipleSigners(payload);

            if (response && response.status===200) {
                const fullSelectedSigners = signers.filter((s) => selectedSigners.includes(s.id));
                setDeleteSignerOpen(false);
                setSelectMode(false);
                dispatch(removeSigner(selectedSigners));
                dispatch(deleteCoordinatesBySigner(fullSelectedSigners));
                setSelectedSigners([]);
                setNumSigners(numSigners - selectedSigners.length);
                fetchSignersData(uploadedDocument?.data?.document_id);
            } else {
                console.error("Failed to delete signer:", response);
            }
        } catch (error) {
            console.error("Error deleting signer:", error);
        }
    };

    const areDigitalSignersOnTop = (signers) => {
        let foundNonDigital = false;
      
        for (const signer of signers) {
          if (signer.esign_type_new === "digital-signature") {
            if (foundNonDigital) {
              return false;
            }
          } else {
            foundNonDigital = true;
          }
        }
      
        return true;
    };
    
    const isReviewDisabled = () => {
        if (!signers || signers.length === 0) return true;
      
        let disabled = false;
      
        signers.forEach((signer) => {
          const signerLabel = `signer-${signer.sequence}`;
          const match = coordinates.find(coord => coord.value === signerLabel);
          console.log(match)
          if (!match) {
            disabled = true;
          }
        });  
        return disabled;
    };

  return (
    openSideBar && (
        <Stack sx={{ height: '100%', width: '80%' }}>
            <Box sx={{ height: '80px', display: "flex", alignItems:'center', justifyContent: "space-between", padding: "28px 20px" }}>
                <Typography noWrap component="p" sx={{ fontSize: '20px', fontWeight: 600, lineHeight: '20px', color: "#1D1D1D", paddingBottom: "2px"}}>
                    Signers
                </Typography>
                { signers.length > 0 && (
                    <Button variant="contained" sx={{ width: '133px', height: 40, color: "#fff", background: "#185CB7", textTransform: "none", fontSize: "14px", borderRadius: "10px", boxShadow: "none", fontWeight: "4    00", "&:hover": { background: "#185CB7" },}} onClick={(e) => {AddMoreSigner();}} >
                        + Add More
                    </Button>
                )}
            </Box>
            <Divider sx={{ borderWidth : "1px" }} />
            <Box sx={{ height: 46, background: "linear-gradient(93.93deg, rgba(24, 92, 183, 0.06) 30.05%, rgba(205, 48, 77, 0.06) 95.93%)", display: 'flex', justifyContent: "space-between", alignItems: "center",padding: "17px 21px" }}>
                {!selectMode ? (<>
                    <Box sx={{ display: 'flex', gap: 2, }}>
                        <Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#000000' }}>
                            Aadhaar Signers: {aadhaarCount}
                        </Typography>
                        <Typography sx={{ fontWeight: 400, fontSize: '14px', color: '#000000' }}>
                            Digital Signers: {digitalCount}
                        </Typography>
                    </Box>
                    {signers.length > 0 && (
                        <Box sx={{cursor: "pointer", display: "flex" }} onClick={(e) => handleSelectSignerOpen(e)}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M13 4C13 5.10457 12.1046 6 11 6C9.89543 6 9 5.10457 9 4C9 2.89543 9.89543 2 11 2C12.1046 2 13 2.89543 13 4ZM13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11ZM11 20C12.1046 20 13 19.1046 13 18C13 16.8954 12.1046 16 11 16C9.89543 16 9 16.8954 9 18C9 19.1046 9.89543 20 11 20Z"
                                fill="#1D1D1D"
                            />
                            </svg>
                        </Box>
                    )}
                </>) : (<>
                    <Box 
                        sx={{ 
                            cursor: "pointer", 
                            fontWeight: 500, 
                            fontWeight: 400, fontSize: '14px', color: '#000000',
                            display: "flex", 
                            alignItems: "center",
                            gap: "15px"
                        }}
                    >
                        <Checkbox
                            sx={{ p: 0 }}
                            checked={selectedSigners.length === signers.length}
                            indeterminate={selectedSigners.length > 0 && selectedSigners.length < signers.length}
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedSigners(signers.map((s) => s.id));
                                } else {
                                    setSelectedSigners([]);
                                }
                            }}
                        />
                        {selectedSigners.length} Selected
                    </Box>
                    
                    <Box sx={{ display: "flex", alignItems: "center", gap: "25px" }}>
                        {selectedSigners.length > 0 &&(<>
                            <Box sx={{ display: "flex", cursor: "pointer" }} onClick={() => setEditSelectSignerOpen(true)}>
                                {esignIcons.editIconBlue}
                            </Box>
                            <Box sx={{ display: "flex", cursor: "pointer" }} onClick={handleDelete}>
                                {esignIcons.deleteIconRed}
                            </Box>
                        </>)}
                        <Box sx={{ display: "flex", cursor: "pointer" }} onClick={() => { setSelectMode(false); setSelectedSigners([]); setSelectedEsignType(""); }}>
                            {esignIcons.circleCrossIcon}
                        </Box>
                    </Box>
                    
                </>)}
                
                <Menu anchorEl={anchorSelectSigner} open={Boolean(anchorSelectSigner)} onClose={handleSelectSignerClose} PaperProps={{
                    sx: {
                        width: "128px",
                        borderRadius: "10px",
                    },
                }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center", 
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                >
                    <MenuItem onClick={handleSelectSigners} sx={{ fontSize: "14px", fontWeight: "400", color: "#595959", p: 0, display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent !important", }, "&.Mui-focusVisible": { backgroundColor: "transparent", }, "&.Mui-selected": { backgroundColor: "transparent", }, "&.Mui-selected:hover": { backgroundColor: "transparent", } }}
                    >
                        Select Signer
                    </MenuItem>
                </Menu>
            </Box>
            <Divider sx={{ borderWidth : "1px" }} />
            <Box
            sx={{
                borderRadius: '12px',
                background: '#fff',
                width: "100%",
                height: "calc(100% - 126px)",
                display: "flex",
                flexDirection: "column"
            }}
            >
                <Box sx={{ padding: "16px 20px", display: "flex", flexDirection: "column", overflow: "auto", height: "100%" }}>
                    { signers.length === 0 && (
                    <Box sx={{ padding: "2em"}}>
                        <Typography textAlign="center" sx={{ fontSize: 18, fontWeight: 600, lineHeight: "24px" }}>
                            No Signer Added!
                        </Typography>
                        <Typography textAlign="center" mt={1} sx={{ fontSize: 14, fontWeight: 400, lineHeight: "24px" }}>
                            Add signers to finalize the document. Click below to proceed.
                        </Typography>
                        <Button variant="contained" sx={{ mt: 2.5, width: '172px', height: 46, color: "#fff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", boxShadow: "none", fontWeight: "500", "&:hover": { background: "#185CB7" }, }} onClick={() => {AddMoreSigner();}} >
                            + Add Signer
                        </Button>
                    </Box>
                    )}

                    <DragDropContext onDragEnd={handleDragEnd}>
                        <Droppable droppableId="signers">
                            {(provided) => (
                            <Box ref={provided.innerRef} {...provided.droppableProps} sx={{
                                display: 'block',
                              }} >
                                {signers.map((signer, index) => (
                                <Draggable draggableId={signer.id.toString()} index={index} key={signer.id}>
                                    {(provided, snapshot) => (
                                    <Card
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            p: 2,
                                            mb: 2,
                                            borderRadius: "12px",
                                            boxShadow: "none",
                                            height: "80px",
                                            background: snapshot.isDragging ? "#d3f3ff" : "#F9F9F9",
                                            border: "1px solid #DFDFDF",
                                            overflow: 'hidden', // 👈 prevents jumpy layout
                                            width: '100%',      // 👈 prevents "moving right"
                                            boxSizing: 'border-box',
                                        }}
                                    >
                                        <Box sx={{ display: "flex", alignItems: "center", position: "relative", width: "100%" }}>
                                            {selectMode && (
                                                <Checkbox sx={{ p: 0 }} checked={selectedSigners.includes(signer.id)} onChange={() => handleCheckboxChange(signer.id)}
                                                />
                                            )}
                                            <Box {...provided.dragHandleProps}  sx={{ cursor: "grab", display: selectMode ? "none" : "block", transition: "opacity 0.2s ease", }}>
                                                <svg width="15" height="28" viewBox="0 0 10 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="2" cy="26" r="2" transform="rotate(-90 2 26)" fill="#333333"/>
                                                    <circle cx="2" cy="20" r="2" transform="rotate(-90 2 20)" fill="#333333"/>
                                                    <circle cx="2" cy="14" r="2" transform="rotate(-90 2 14)" fill="#333333"/>
                                                    <circle cx="2" cy="8" r="2" transform="rotate(-90 2 8)" fill="#333333"/>
                                                    <circle cx="2" cy="2" r="2" transform="rotate(-90 2 2)" fill="#333333"/>
                                                    <circle cx="8" cy="26" r="2" transform="rotate(-90 8 26)" fill="#333333"/>
                                                    <circle cx="8" cy="20" r="2" transform="rotate(-90 8 20)" fill="#333333"/>
                                                    <circle cx="8" cy="14" r="2" transform="rotate(-90 8 14)" fill="#333333"/>
                                                    <circle cx="8" cy="8" r="2" transform="rotate(-90 8 8)" fill="#333333"/>
                                                    <circle cx="8" cy="2" r="2" transform="rotate(-90 8 2)" fill="#333333"/>
                                                </svg>
                                            </Box>

                                            <Box sx={{ textAlign: "left", ml: 1 }}>
                                                <Typography variant="caption" sx={{ fontSize: "12px", fontWeight: "500", color: "#185CB7" }}>
                                                SIGNER {index + 1}
                                                </Typography>
                                                <Typography
                                                    variant="h6"
                                                    sx={{
                                                        fontSize: "16px",
                                                        fontWeight: "600",
                                                        color: "#1D1D1D",
                                                        width: "200px",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }}
                                                >
                                                {signer.name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
                                                </Typography>
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        fontSize: "12px",
                                                        fontWeight: "300",
                                                        color: "#595959",
                                                        width: "200px",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }}
                                                >
                                                    {signer.email}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ position: "absolute", right: 0, top: 10, display: "flex", alignItems: "center", gap: "4px"}}>
                                                <Box sx={{ background: signer.esign_type_new=='digital-signature' ? "#EBF3FF" : "#FFF0E2", borderRadius: "5px", padding: "6px 9px" }}>
                                                    <Typography sx={{ fontSize: "10px", fontWeight: "400", color: signer.esign_type_new=='digital-signature' ? "#185CB7" : "#F58220",}}>{signer.esign_type_new=='digital-signature' ? 'Digital Sign' : 'Aadhaar eSign'}</Typography>
                                                </Box>
                                                {!selectMode && ( 
                                                    <Box sx={{cursor: "pointer", display: "flex" }} onClick={(e) => handleMenuOpen(e, signer)}>
                                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            fillRule="evenodd"
                                                            clipRule="evenodd"
                                                            d="M13 4C13 5.10457 12.1046 6 11 6C9.89543 6 9 5.10457 9 4C9 2.89543 9.89543 2 11 2C12.1046 2 13 2.89543 13 4ZM13 11C13 12.1046 12.1046 13 11 13C9.89543 13 9 12.1046 9 11C9 9.89543 9.89543 9 11 9C12.1046 9 13 9.89543 13 11ZM11 20C12.1046 20 13 19.1046 13 18C13 16.8954 12.1046 16 11 16C9.89543 16 9 16.8954 9 18C9 19.1046 9.89543 20 11 20Z"
                                                            fill="#1D1D1D"
                                                        />
                                                        </svg>
                                                    </Box>
                                                )}
                                            </Box>
                                        </Box>
                                    </Card>
                                    )}
                                </Draggable>
                                ))}
                                {provided.placeholder}
                            </Box>
                            )}
                        </Droppable>
                    </DragDropContext>

                    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose} PaperProps={{
                            sx: {
                                height: "83px",
                                width: "118px",
                                borderRadius: "10px",
                            },
                        }}
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center", 
                        }}
                        transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                    >
                        <MenuItem onClick={handleEdit} sx={{ fontSize: "14px", fontWeight: "400", color: "#595959", gap: 1, }}>
                            {esignIcons.editIcon} Edit
                        </MenuItem>
                        <MenuItem onClick={handleDelete} sx={{ fontSize: "14px", fontWeight: "400", color: "#595959", gap: 1 }}>
                            {esignIcons.delteIcon} Delete
                        </MenuItem>
                    </Menu>

                </Box>
                {isReviewDisabled() && (
                <Box sx={{ height: 32, width: "100%", background: "#E6F1FF", borderWidth: "1px 0", borderColor: "#C5DEFF", borderStyle:"solid", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Typography sx={{ fontSize: "13px", fontWeight: "400", color: "#1D1D1D" }} >
                        Map all signers in document to proceed.
                    </Typography>
                </Box>
                )}
                <Box sx={{ padding: "16px 20px", display: "flex", width: "100%", justifyContent: "space-between", mt: "auto" }}>
                    <PdfControls
                        containerRef={containerRef}
                        pdfPagesRef={pdfPagesRef}
                        pdfPages={pdfPages}
                        handleReviewAndSend={handleReviewAndSend}
                        areDigitalSignersOnTop={areDigitalSignersOnTop}
                        setSignerSequenceMismatch={setSignerSequenceMismatch}
                    />
                </Box>
            </Box>

            <Modal open={editSelectSignerOpen} onClose={() => setEditSelectSignerOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "555px",
                        maxHeight: "600px",
                        backgroundColor: "#fff",
                        boxShadow: 24,
                        overflow: "auto",
                        borderRadius: "20px",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "20px 30px" }}>
                        <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Edit Signature Method</Typography>
                    </Box>
                    <Box sx={{ background: "linear-gradient(93.93deg, rgba(24, 92, 183, 0.06) 30.05%, rgba(205, 48, 77, 0.06) 95.93%)", height: "111px", padding: "20px 30px" }}>
                        <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 400, color: "#1D1D1D" }}>You can update the signature method for the selected signer's by choosing between Aadhaar eSign and Digital Signature.</Typography>
                    </Box>
                    <Box sx={{ padding: "30px 28px" }}>
                        <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: 400, color: "#434343" }}>Signature Type</Typography>
                        <TextField
                            select
                            variant="outlined"
                            fullWidth
                            value={selectedEsignType}
                            onChange={handleEsignTypeChange}
                            SelectProps={{ native: true }}
                            sx={{
                                boxSizing: "border-box",
                                borderRadius: "10px",
                                backgroundColor: "#fff",
                                borderColor: "#C0C0C0",
                                borderWidth: "5px",
                                mt: "16px",
                                "& .MuiOutlinedInput-root": {
                                    borderColor: "#C0C0C0",
                                    backgroundColor: "none",
                                    "&:hover fieldset": {
                                        borderColor: "#C0C0C0",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#C0C0C0",
                                    },
                                },
                                "& .MuiFormHelperText-root": {
                                    color: "#FF6666",
                                },
                            }}
                            InputProps={{
                                sx: {
                                    borderRadius: "10px",
                                    height: 46,
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    "& input::-ms-reveal, & input::-ms-clear": {
                                        display: "none",
                                    },
                                },
                            }}
                        >
                            <option value="aadhaar-signature">Aadhaar e-Sign</option>
                            <option value="digital-signature">Digital Signature</option>
                        </TextField>
                    </Box>
                    <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
                    <Box sx={{ p: "0 30px", mb: 3}}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>
                            <Button variant="contained" sx={{ width: '130px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => setEditSelectSignerOpen(false)} >
                                Cancel
                            </Button>
                            <Button variant="contained" sx={{ width: '155px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"} }} onClick={handleUpdateEsignType} >
                                Update
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Modal open={previewOpen} onClose={() => setPreviewOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "720px",
                        maxHeight: "600px",
                        backgroundColor: "#fff",
                        boxShadow: 24,
                        overflow: "auto",
                        borderRadius: "20px",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "20px 30px" }}>
                        <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>{updateSigner ? "Edit Signer" : "Add Signer"}</Typography>
                        {!updateSigner &&
                        <Box sx={{ background : "#F3F3F3", width: "321px", height: 52, borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "space-around" }}>
                            <Button variant="contained" sx={{ width: '154px', height: 45, color: newSigner ? "#185CB7": "#1D1D1D", background: newSigner ?"#ffffff" : "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", boxShadow: "none", fontWeight: "500",}} onClick={() => {setNewSigner(true); setAddedSigners(false);}} >
                                New Signer
                            </Button>
                             <Button variant="contained" sx={{ width: '154px', height: 45, color: addedSigners ? "#185CB7": "#1D1D1D", background: addedSigners ? "#ffffff" : "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", boxShadow: "none", fontWeight: "500",}} onClick={() => { setAddedSigners(true); setNewSigner(false); fetchfrequentSignersData(); setCheckedSigners({}) }} >
                                Added Signers
                            </Button>
                        </Box>
                            }
                    </Box>
                    <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />

                    {newSigner && (<>
                        <Box sx={{ p: "25px 30px" }}>
                            <Box sx={{ display: "flex", gap: 2, mb: 3, justifyContent: "space-between" }}>
                                <Box width={"315px"}>
                                    <TextField
                                        placeholder="Name*"
                                        type="text"
                                        variant="outlined"
                                        fullWidth
                                        value={signername}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^[a-zA-Z\s]*$/.test(value) && value.length <= 50) {
                                                setSignerName(value);
                                                setErrors((prevErrors) => ({ ...prevErrors, signername: "" }));
                                                setHelperText((prevHelperText) => ({ ...prevHelperText, signername: "" }));
                                            }
                                        }}
                                        error={!!errors.signername}
                                        sx={{
                                        boxSizing: "border-box",
                                        borderRadius: "10px",
                                        backgroundColor: "#fff",
                                        borderColor: "#C0C0C0",
                                        borderWidth: "5px",
                                        "& .MuiOutlinedInput-root": {
                                            borderColor: errors.signername ? "#FF6666" : "#C0C0C0",
                                            backgroundColor: errors.signername ? "#FFF1F1" : "none",
                                            "&:hover fieldset": {
                                            borderColor: errors.signername ? "#FF6666" : "#C0C0C0",
                                            },
                                            "&.Mui-focused fieldset": {
                                            borderColor: errors.signername ? "#FF6666" : "#C0C0C0",
                                            },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            color: "#FF6666",
                                        },
                                        }}
                                        InputProps={{
                                        sx: { 
                                            borderRadius: "10px",
                                            height: 46,
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            "& input::-ms-reveal, & input::-ms-clear": {
                                                display: "none",
                                            },
                                        },
                                        }}
                                    />
                                    
                                    {!! errors.signername && (
                                        <Typography
                                        sx={{
                                            color: "#FF6666",
                                            fontSize: "12px",
                                            mt: 0.5,
                                            mb: 0,
                                            marginRight: "auto"
                                        }}
                                        >
                                        {helperText.signername}
                                        </Typography>
                                    )}
                                </Box>
                                <Box width={"315px"}>
                                    <TextField
                                        placeholder="Email*"
                                        type="email"
                                        variant="outlined"
                                        fullWidth
                                        value={signeremail}
                                        onChange={(e) => {
                                        setSignerEmail(e.target.value)
                                        setErrors((prevErrors) => ({ ...prevErrors, signeremail: "" }));
                                        setHelperText((prevHelperText) => ({ ...prevHelperText, signeremail: "" }))
                                    }}
                                        error={!!errors.signeremail}
                                        sx={{
                                        boxSizing: "border-box",
                                        borderRadius: "10px",
                                        backgroundColor: "#fff",
                                        borderColor: "#C0C0C0",
                                        borderWidth: "5px",
                                        "& .MuiOutlinedInput-root": {
                                            borderColor: errors.signeremail ? "#FF6666" : "#C0C0C0",
                                            backgroundColor: errors.signeremail ? "#FFF1F1" : "none",
                                            "&:hover fieldset": {
                                            borderColor: errors.signeremail ? "#FF6666" : "#C0C0C0",
                                            },
                                            "&.Mui-focused fieldset": {
                                            borderColor: errors.signeremail ? "#FF6666" : "#C0C0C0",
                                            },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            color: "#FF6666",
                                        },
                                        }}
                                        InputProps={{
                                        sx: { 
                                            borderRadius: "10px",
                                            height: 46,
                                            fontSize: "16px",
                                            fontWeight: "500",
                                            "& input::-ms-reveal, & input::-ms-clear": {
                                                display: "none",
                                            },
                                        },
                                        }}
                                        inputProps={{ maxLength: 100 }}
                                    />
                                    
                                    {!! errors.signeremail && (
                                        <Typography
                                        sx={{
                                            color: "#FF6666",
                                            fontSize: "12px",
                                            mt: 0.5,
                                            mb: 0,
                                            marginRight: "auto"
                                        }}
                                        >
                                        {helperText.signeremail}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>

                            <Box sx={{ display: "flex", gap: 2, mb: 3, justifyContent: "space-between" }}>
                                <Box width={"315px"}>
                                    <TextField
                                        placeholder="Mobile"
                                        type="number"
                                        variant="outlined"
                                        fullWidth
                                        value={singerNumber}
                                        onChange={(e) => {
                                            const inputValue = e.target.value.slice(0, 10);
                                            setSignerNumber(inputValue);
                                            setErrors((prevErrors) => ({ ...prevErrors, singerNumber: "" }));
                                            setHelperText((prevHelperText) => ({ ...prevHelperText, singerNumber: "" }))
                                        }}
                                        onKeyDown={(e) => {
                                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                                              e.preventDefault();
                                            }
                                        }}
                                        onPaste={(e) => {
                                            const paste = e.clipboardData.getData('text');
                                            if (!/^\d+$/.test(paste)) {
                                              e.preventDefault();
                                            }
                                        }}
                                        error={!!errors.singerNumber}
                                        sx={{
                                        boxSizing: "border-box",
                                        borderRadius: "10px",
                                        backgroundColor: "#fff",
                                        borderColor: "#C0C0C0",
                                        borderWidth: "5px",
                                        "& .MuiOutlinedInput-root": {
                                            borderColor: errors.singerNumber ? "#FF6666" : "#C0C0C0",
                                            backgroundColor: errors.singerNumber ? "#FFF1F1" : "none",
                                            "&:hover fieldset": {
                                            borderColor: errors.singerNumber ? "#FF6666" : "#C0C0C0",
                                            },
                                            "&.Mui-focused fieldset": {
                                            borderColor: errors.singerNumber ? "#FF6666" : "#C0C0C0",
                                            },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            color: "#FF6666",
                                        },
                                        }}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start" sx={{ height: "46px", paddingRight: "12px", borderRight: "1px solid #C0C0C0", maxHeight: "46px", }}>
                                                    <Typography
                                                        sx={{
                                                            color: "#1D1D1D",
                                                            fontSize: "16px",
                                                            fontWeight: 500,
                                                            transition: "color 0.2s ease-in-out",
                                                            textDecoration: "none",
                                                        }}
                                                        >
                                                        +91
                                                    </Typography>
                                                </InputAdornment>
                                            ),
                                            sx: { 
                                                borderRadius: "10px",
                                                height: 46,
                                                fontSize: "16px",
                                                fontWeight: "500",
                                                "& input::-ms-reveal, & input::-ms-clear": {
                                                    display: "none",
                                                },
                                                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                                                    display: "none",
                                                    WebkitAppearance: "none",
                                                    margin: 0,
                                                },
                                                "& input[type=number]": {
                                                    MozAppearance: "textfield",
                                                },
                                            },
                                        }}
                                    />
                                    {!! errors.singerNumber && (
                                        <Typography
                                        sx={{
                                            color: "#FF6666",
                                            fontSize: "12px",
                                            mt: 0.5,
                                            mb: 0,
                                            marginRight: "auto"
                                        }}
                                        >
                                        {helperText.singerNumber}
                                        </Typography>
                                    )}
                                </Box>
                                <Box width={"315px"}>
                                    <TextField
                                        placeholder="Place*"
                                        type="text"
                                        variant="outlined"
                                        fullWidth
                                        value={singerPlace}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if ( value?.length <= 50) {
                                                setSignerPlace(e.target.value)
                                                setErrors((prevErrors) => ({ ...prevErrors, singerPlace: "" }));
                                                setHelperText((prevHelperText) => ({ ...prevHelperText, singerPlace: "" }))
                                            }
                                        }}
                                        error={!!errors.singerPlace}
                                        sx={{
                                        boxSizing: "border-box",
                                        borderRadius: "10px",
                                        backgroundColor: "#fff",
                                        borderColor: "#C0C0C0",
                                        borderWidth: "5px",
                                        "& .MuiOutlinedInput-root": {
                                            borderColor: errors.singerPlace ? "#FF6666" : "#C0C0C0",
                                            backgroundColor: errors.singerPlace ? "#FFF1F1" : "none",
                                            "&:hover fieldset": {
                                            borderColor: errors.singerPlace ? "#FF6666" : "#C0C0C0",
                                            },
                                            "&.Mui-focused fieldset": {
                                            borderColor: errors.singerPlace ? "#FF6666" : "#C0C0C0",
                                            },
                                        },
                                        "& .MuiFormHelperText-root": {
                                            color: "#FF6666",
                                        },
                                        }}
                                        InputProps={{
                                            sx: { 
                                                borderRadius: "10px",
                                                height: 46,
                                                fontSize: "16px",
                                                fontWeight: "500",
                                                "& input::-ms-reveal, & input::-ms-clear": {
                                                    display: "none",
                                                },
                                            },
                                        }}
                                    />
                                    {!! errors.singerPlace && (
                                        <Typography
                                        sx={{
                                            color: "#FF6666",
                                            fontSize: "10px",
                                            mt: 0.5,
                                            mb: 0,
                                            marginRight: "auto"
                                        }}
                                        >
                                        {helperText.singerPlace}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>

                            <Box sx={{ display: "flex", gap: 2, mb: 3, flexWrap: "wrap", justifyContent: "space-between" }}>
                                {/* Reason for eSign */}
                                <Box width={"315px"}>
                                    <TextField
                                        select
                                        variant="outlined"
                                        fullWidth
                                        value={signerReason}
                                        onChange={(e) => {
                                            setSignerReason(e.target.value)
                                            setErrors((prevErrors) => ({ ...prevErrors, signerReason: "" }));
                                            setHelperText((prevHelperText) => ({ ...prevHelperText, signerReason: "" }))
                                        }}
                                        SelectProps={{ native: true }}
                                        sx={{
                                            boxSizing: "border-box",
                                            borderRadius: "10px",
                                            backgroundColor: "#fff",
                                            borderColor: "#C0C0C0",
                                            borderWidth: "5px",
                                            "& .MuiOutlinedInput-root": {
                                                borderColor: errors.signerReason ? "#FF6666" : "#C0C0C0",
                                                backgroundColor: errors.signerReason ? "#FFF1F1" : "none",
                                                "&:hover fieldset": {
                                                    borderColor: errors.signerReason ? "#FF6666" : "#C0C0C0",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: errors.signerReason ? "#FF6666" : "#C0C0C0",
                                                },
                                            },
                                            "& .MuiFormHelperText-root": {
                                                color: "#FF6666",
                                            },
                                        }}
                                        InputProps={{
                                            sx: {
                                                borderRadius: "10px",
                                                height: 46,
                                                fontSize: "16px",
                                                fontWeight: "500",
                                                "& input::-ms-reveal, & input::-ms-clear": {
                                                    display: "none",
                                                },
                                            },
                                        }}
                                    >
                                        <option value="">Select reason for esign</option>
                                        <option value="KYC">KYC</option>
                                        <option value="Account Opening">Account Opening</option>
                                        <option value="Agreement">Agreement</option>
                                        <option value="Other">Other</option>
                                    </TextField>
                                    {!!errors.signerReason && (
                                        <Typography sx={{ color: "#FF6666", fontSize: "10px", mt: 0.5 }}>
                                            {helperText.signerReason}
                                        </Typography>
                                    )}
                                </Box>

                                {/* If Other -> show reason input */}
                                {signerReason.toLowerCase() === "other" && (
                                    <Box width={"315px"}>
                                        <TextField
                                            placeholder="Write reason here..."
                                            type="text"
                                            variant="outlined"
                                            fullWidth
                                            value={signerOtherReason}
                                            onChange={(e) => {
                                                setSignerOtherReason(e.target.value)
                                                setErrors((prevErrors) => ({ ...prevErrors, signerOtherReason: "" }));
                                                setHelperText((prevHelperText) => ({ ...prevHelperText, signerOtherReason: "" }))
                                            }}
                                            error={!!errors.signerOtherReason}
                                            sx={{
                                                boxSizing: "border-box",
                                                borderRadius: "10px",
                                                backgroundColor: "#fff",
                                                borderColor: "#C0C0C0",
                                                borderWidth: "5px",
                                                "& .MuiOutlinedInput-root": {
                                                    borderColor: errors.signerOtherReason ? "#FF6666" : "#C0C0C0",
                                                    backgroundColor: errors.signerOtherReason ? "#FFF1F1" : "none",
                                                    "&:hover fieldset": {
                                                        borderColor: errors.signerOtherReason ? "#FF6666" : "#C0C0C0",
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: errors.signerOtherReason ? "#FF6666" : "#C0C0C0",
                                                    },
                                                },
                                                "& .MuiFormHelperText-root": {
                                                    color: "#FF6666",
                                                },
                                            }}
                                            InputProps={{
                                                sx: {
                                                    borderRadius: "10px",
                                                    height: 46,
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    "& input::-ms-reveal, & input::-ms-clear": {
                                                        display: "none",
                                                    },
                                                },
                                            }}
                                            inputProps={{ maxLength: 35 }}
                                        />
                                        {!!errors.signerOtherReason && (
                                            <Typography sx={{ color: "#FF6666", fontSize: "10px", mt: 0.5 }}>
                                                {helperText.signerOtherReason}
                                            </Typography>
                                        )}
                                    </Box>
                                )}

                                {/* Always show eSign Type */}
                                <Box width={"315px"}>
                                    <TextField
                                        select
                                        variant="outlined"
                                        fullWidth
                                        value={signerEsignType}
                                        onChange={(e) => {
                                            setSignerEsignType(e.target.value)
                                            setErrors((prevErrors) => ({ ...prevErrors, signerEsignType: "" }));
                                            setHelperText((prevHelperText) => ({ ...prevHelperText, signerEsignType: "" }))
                                        }}
                                        SelectProps={{ native: true }}
                                        sx={{
                                            boxSizing: "border-box",
                                            borderRadius: "10px",
                                            backgroundColor: "#fff",
                                            borderColor: "#C0C0C0",
                                            borderWidth: "5px",
                                            "& .MuiOutlinedInput-root": {
                                                borderColor: errors.signerEsignType ? "#FF6666" : "#C0C0C0",
                                                backgroundColor: errors.signerEsignType ? "#FFF1F1" : "none",
                                                "&:hover fieldset": {
                                                    borderColor: errors.signerEsignType ? "#FF6666" : "#C0C0C0",
                                                },
                                                "&.Mui-focused fieldset": {
                                                    borderColor: errors.signerEsignType ? "#FF6666" : "#C0C0C0",
                                                },
                                            },
                                            "& .MuiFormHelperText-root": {
                                                color: "#FF6666",
                                            },
                                        }}
                                        InputProps={{
                                            sx: {
                                                borderRadius: "10px",
                                                height: 46,
                                                fontSize: "16px",
                                                fontWeight: "500",
                                                "& input::-ms-reveal, & input::-ms-clear": {
                                                    display: "none",
                                                },
                                            },
                                        }}
                                    >
                                        <option value="aadhaar-signature">Aadhaar e-Sign</option>
                                        <option value="digital-signature">Digital Signature</option>
                                    </TextField>
                                    {!!errors.signerEsignType && (
                                        <Typography sx={{ color: "#FF6666", fontSize: "10px", mt: 0.5 }}>
                                            {helperText.signerEsignType}
                                        </Typography>
                                    )}
                                </Box>
                            </Box>


                            {!updateSigner && <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 3 }}>
                                <Grid item>
                                    <FormControlLabel
                                    control={
                                        <Checkbox
                                        checked={saveFutureRefrences}
                                        onChange={handlesaveFutureRefrences}
                                        sx={{ color: "#C0C0C0",
                                            "&.Mui-checked": { color: "#185CB7" },
                                            "& .MuiSvgIcon-root": {
                                                fontSize: 25,
                                            },
                                            padding: "0",
                                        }}
                                        />
                                    }
                                    sx={{
                                        color: "#595959",
                                        fontSize: "5px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "3px",
                                        margin: "0",
                                        "& .MuiTypography-root": {
                                            marginLeft: "0",
                                            fontSize: "15px",
                                        },
                                    }}
                                    />
                                </Grid>
                                <Typography textAlign="center" sx={{ fontSize: 14, fontWeight: 400, lineHeight: "24px", color: "#555555" }}>
                                    Save my future preferences
                                </Typography>
                            </Box>}
                        </Box> 
                        </>
                    )}

                    {addedSigners && (
                        <>
                            <Box sx={{ p: 3 }}>
                            <TextField
                                        fullWidth
                                        placeholder="Search..."
                                        variant="outlined"
                                        size="small"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                        sx={{
                                            mb: 2,
                                            background: "#F5F5F5",
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "10px",
                                            },
                                        }}
                                        InputProps={{
                                            sx: { 
                                                borderRadius: "10px",
                                                height: 42,
                                                fontSize: "15px",
                                                fontWeight: "400",
                                                color: "#6F6F6F",
                                                "& input::-ms-reveal, & input::-ms-clear": {
                                                    display: "none",
                                                },
                                            },
                                        }}
                                    />
                                {filteredSigners.length > 0 ? (<>
                                    <Grid container spacing={3.5}>
                                        {filteredSigners.map((signer, index) => (
                                            <Grid item xs={12} sm={6} key={signer.id}>
                                                <Box sx={{ display: "flex", gap: 2, mb: 3, alignItems: "center", justifyContent: "space-between", mb:0, }}>
                                                    <Box sx={{ textAlign: "left" }}>
                                                        <Typography variant="h6" sx={{ fontSize: "16px", fontWeight: "500", color: "#1D1D1D", maxWidth: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                            {signer.name}
                                                        </Typography>
                                                        <Typography variant="body2" sx={{ fontSize: "14px", fontWeight: "400", color: "#595959", maxWidth: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                            {signer.email}
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <Grid item>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={checkedSigners[signer.id] || false}
                                                                        onChange={(e) => handleAddSavedSigner(e, signer.id)}
                                                                        sx={{
                                                                            color: "#C0C0C0",
                                                                            "&.Mui-checked": { color: "#185CB7" },
                                                                            "& .MuiSvgIcon-root": { fontSize: 25 },
                                                                            padding: "0",
                                                                        }}
                                                                    />
                                                                }
                                                                sx={{
                                                                    color: "#595959",
                                                                    fontSize: "5px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "3px",
                                                                    margin: "0",
                                                                    "& .MuiTypography-root": { marginLeft: "0", fontSize: "15px" },
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                            </Grid>
                                        ))}
                                    </Grid>
                                    </>
                                ) : (
                                    <Box sx={{ padding: "2em", display: "flex", flexDirection: "column", alignItems: "center" }}>
                                        
                                        <Typography textAlign="center" mt={1} sx={{ fontSize: 14, fontWeight: 400, lineHeight: "24px", width: "45%" }}>
                                           No data found!
                                        </Typography>
                                      
                                    </Box>
                                )}
                            </Box>
                            
                        </>
                    )}
                        
                    <Divider sx={{ borderWidth : "1px", }} />
                        
                    <Box sx={{ p: "0 30px", mb: 3}}>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}>
                            <Button variant="contained" sx={{ width: '130px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => setPreviewOpen(false)} >
                                Cancel
                            </Button>
                            <Button variant="contained" sx={{ width: '155px', height: 46, color: "#ffffff", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #185CB7", boxShadow: "none", fontWeight: "500", "&:disabled": {background: "#E4E4E4", color: "#ffffff", borderColor: "#E4E4E4"} }} onClick={() => updateSigner ? handleAddOrUpdateSigners(true) : addedSigners ? handleAddFrequentSigners() : handleAddOrUpdateSigners(false)} >
                                {updateSigner ? "Update" : "Add"}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Modal open={deleteSignerOpen} onClose={() => setDeleteSignerOpen(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "434px",
                        height: "368px",
                        backgroundColor: "#fff",
                        boxShadow: 24,
                        overflow: "auto",
                        borderRadius: "20px",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", p: "1em 1em  1em 2em" }}>
                        <Typography variant="h6" sx={{ fontSize: "22px", fontWeight: 600, color: "#1D1D1D" }}>Delete Signer</Typography>
                    </Box>
                    <Divider sx={{ borderWidth : "1px", margin: 0, padding: 0 }} />
                    <Box sx={{ p: "1em 2em", mb: 3, display: "flex", flexDirection: "column", justifyContent: "space-between", height: "74%" }}>
                        <Box>
                            <img src={`${process.env.PUBLIC_URL}/images/delete.gif`} alt="delete" style={{ height: 83 }} />
                        </Box>
                        <Typography variant="p" sx={{ fontSize: "20px", fontWeight: 400, color: "#1D1D1D" }}>
                        {selectedSigners.length > 0 ? "Are you sure you want to delete all the selected signer?" : "Are you sure you want to delete this signer?"}
                        </Typography>
                        <Box sx={{ display: "flex", justifyContent: "space-between", mt: "auto", gap: 2 }}>
                            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#1D1D1D", background: "transparent", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #D2D2D2", boxShadow: "none", fontWeight: "500",}}  onClick={() => setDeleteSignerOpen(false)} >
                                No
                            </Button>
                            <Button variant="contained" sx={{ width: '171px', height: 46, color: "#ffffff", background: "#C5060B", textTransform: "none", fontSize: "16px", borderRadius: "10px", border: "1px solid #C5060B", boxShadow: "none", fontWeight: "500",}} onClick={selectedSigners.length > 0 ? handleDeleteSelectedSigners : handleDeleteSigners} >
                                Delete
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <Modal open={signerSequenceMismatch} onClose={() => setSignerSequenceMismatch(false)}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "755px",
                        // height: "400px",
                        backgroundColor: "#fff",
                        boxShadow: 24,
                        overflow: "hidden",
                        borderRadius: "20px",
                    }}
                >
                    <Box display="flex" alignItems="center" justifyContent="space-evenly">
                        <Box sx={{ alignSelf: "center" }}>
                            <img src={`${process.env.PUBLIC_URL}/images/signerOrder.gif`} alt="signerOrder" style={{ height: 377.5 }} />
                            {/* <Box
                                component="video"
                                controls
                                src={`${process.env.PUBLIC_URL}/images/signerOrder.mp4`}
                                sx={{
                                    width: '100%',
                                    borderRadius: 2,
                                    boxShadow: 3,
                                }}
                                width= "377.5px"
                                height= "377.5px"
                            /> */}
                        </Box>
                        <Divider flexItem orientation="vertical" sx={{ borderWidth: "0 0 0 thin !important", margin: 0, borderColor: "#EEEEEE", }} />
                        <Box sx={{ p: "39px 20px 27px 20px", display: "flex", flexDirection: "column", justifyContent: "space-between", }}>
                            <Box sx={{ alignSelf: "center" }}>
                                <img src={`${process.env.PUBLIC_URL}/images/warning.svg`} alt="warning" style={{ height: 55 }} />
                            </Box>
                            <Typography variant="p" sx={{ fontSize: "16px", fontWeight: 500, color: "#1D1D1D", textAlign: "center", mt: "19px" }}>
                                “Place all the Digital Signers before the Aadhaar Signers.” 
                            </Typography>
                            <Box sx={{ background: "#F8F8F8", borderRadius: "12px", width: "100%", p: "16px 14px", mt: "25px" }}>
                                <Box display="flex" alignItems="center" width="100%" justifyContent="center" mb="15px">
                                    <Divider sx={{ flex: 0.4, height: "1.6px", border: "none", backgroundImage: "linear-gradient(to left, #D9D9D9 40%, transparent 100%)", }} />
                                    <Typography variant="h6" sx={{ mx: 2, color: "#1D1D1D", fontWeight: 500, fontSize: "12px" }} >
                                        NOTE
                                    </Typography>
                                    <Divider sx={{ flex: 0.4, height: "1.6px", border: "none", backgroundImage: "linear-gradient(to right, #D9D9D9 40%, transparent 100%)", }} />
                                </Box>
                                <Typography sx={{ color: "#5D5D5D", fontSize: "12px", fontWeight: "400", textAlign: "center" }}>Once a document is e-signed, any changes or actions on it, can make it invalid. Make sure all signers are placed in the correct order before starting the signing process.</Typography>
                            </Box>
                            <Box sx={{ display: "flex", justifyContent: "center", mt: "25px", gap: 2 }}>
                                <Button variant="contained" sx={{ width: '100%', height: 46, color: "#FFFFFF", background: "#185CB7", textTransform: "none", fontSize: "16px", borderRadius: "10px", boxShadow: "none", fontWeight: "500",}}  onClick={() => setSignerSequenceMismatch(false)} >
                                    Ok, Got it!
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Modal>
            
            <ReviewAndSend signers={signers} reviewAndSend={reviewAndSend} setReviewAndSend={setReviewAndSend} saveDraft={saveDraft} setSaveDraft={setSaveDraft}  />
        </Stack>
    )
  );
}
